// extracted by mini-css-extract-plugin
export default {"headerValue":"TagHeader_headerValue__hS5HI"};